/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { useHistory } from 'react-router-dom';
import { TextField } from '@material-ui/core';
import React, { useState, useEffect, useMemo, useRef } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { setDisabled } from '../../store/action';
import { checkActionAccessByRole } from '../../../../../SharedModules/utilities/utilities';
import CommonModal from '../../../../../SharedModules/Dialog/CommonModal';
import {
  NO_LESS_THAN_ZERO,
  BILLED_UNITS_ONLY_ZERO,
} from '../../../../../SharedModules/Errors/constantMessageData';
import { handleOnKeyDownEventWithSelectValue } from '../../../../../SharedModules/CommonUtilities/commonUtilities';

const CustomSelectedClaimTextField = React.memo((props) => {
  const { value, data, column, rowIndex, node, systemParameter } = props;
  const { colId } = column;
  const history = useHistory();

  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);

  const selectedClaimMode = useSelector(
    (state) => state.sharedState.claim.selectedClaimMode
  );

  const def_override = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.def_override
  );
  const sys_override = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.sys_override
  );
  const pgm_detail = useSelector(
    (state) => state?.sharedState?.MaintainRebateReducer?.pgm_detail
  );

  const [hasAccess, setHasAccess] = React.useState(
    checkActionAccessByRole(process.env.REACT_APP_HIDE_ACCESS_ROLES, kcRoles)
  );
  const [isEnablebyRole, setIsEnablebyRole] = useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );
  const [openModal, setOpenModal] = React.useState(false);
  const [modalMessage, setModalMessage] = React.useState('');

  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState(value);
  const [isRed, setIsRed] = useState(false);
  const focusValueRef = useRef(null);
  const localStore = JSON.parse(localStorage.getItem('tabItemsData'));

  const useDefSystemInd =
    def_override?.useDefSystemInd ?? pgm_detail?.useDefSystemInd;
  const nonZeroBilledUnitsInd =
    def_override?.nonZeroBilledUnitsInd ?? pgm_detail?.nonZeroBilledUnitsInd;

  const isIndicatorOn = (indicator) => Number(indicator) === 1;

  const getDefNonZeroBilledUnitsInd = () =>
    systemParameter?.paramGeneralVO?.[0]?.defNonZeroBilledUnitsInd ??
    sys_override?.defNonZeroBilledUnitsInd;

  useEffect(() => {
    setInputValue(formatInputValue(value));
  }, [value]);

  React.useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setHasAccess(
        checkActionAccessByRole(
          process.env.REACT_APP_HIDE_ACCESS_ROLES,
          kcRoles
        )
      );
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);
  const is508NotReq = useSelector(
    (state) => state?.sharedState.UserDefaultReducer.override508Compliance
  );
  const formatInputValue = (value1) => {
    let val = parseFloat(value1);
    if (typeof val === 'number' && !isNaN(val)) {
      const formattedValue = Math.abs(val).toFixed(4);
      return val >= 0 ? formattedValue : `(${formattedValue})`;
    }
    return val;
  };

  const getNumericValue = (val) => {
    if (val !== null && val !== undefined && !isNaN(parseFloat(val))) {
      return parseFloat(val);
    }
    return 0;
  };

  const getFocusNumericValue = () => {
    if (focusValueRef.current !== null && focusValueRef.current !== undefined) {
      return focusValueRef.current;
    }
    return getNumericValue(value);
  };

  const isNonZeroBilledUnitsAllowed = () => {
    if (isIndicatorOn(useDefSystemInd)) {
      return isIndicatorOn(getDefNonZeroBilledUnitsInd());
    }
    if (Number(useDefSystemInd) === 0) {
      return isIndicatorOn(nonZeroBilledUnitsInd);
    }
    return true;
  };

  const shouldValidateNonZeroBilledUnits = () =>
    isIndicatorOn(useDefSystemInd) || Number(useDefSystemInd) === 0;

  const revertToFocusValue = () => {
    const revertValue = getFocusNumericValue();
    setInputValue(formatInputValue(revertValue));
    props.node.setDataValue(colId, revertValue);
    setIsRed(false);
  };

  const handleBlur = (e) => {
    const rawValue = e.target.value.trim();
    const inputVal = rawValue === '' ? '0' : rawValue;
    const parsedValue = parseFloat(inputVal);

    if (isNaN(parsedValue)) {
      return;
    }

    const formattedValue = formatInputValue(parsedValue);
    const focusNumericValue = getFocusNumericValue();
    const valueUnchanged = parsedValue === focusNumericValue;

    if (parsedValue < 0) {
      setIsRed(true);
      setOpenModal(true);
      setModalMessage(
        column?.colId === 'billedUnits'
          ? `Billed units ${NO_LESS_THAN_ZERO}`
          : `Number of Units ${NO_LESS_THAN_ZERO}`
      );
      revertToFocusValue();
      return;
    }

    if (
      colId === 'billedUnits' &&
      shouldValidateNonZeroBilledUnits() &&
      !isNonZeroBilledUnitsAllowed() &&
      parsedValue !== 0 &&
      !valueUnchanged
    ) {
      setOpenModal(true);
      setModalMessage(BILLED_UNITS_ONLY_ZERO);
      revertToFocusValue();
      return;
    }

    setInputValue(formattedValue);
    props.node.setDataValue(colId, parsedValue);
    setIsRed(false);
  };

  const handleFocus = () => {
    focusValueRef.current = getNumericValue(value);
  };

  const handleCloseModal = () => {
    revertToFocusValue();
    setOpenModal(false);
  };


  const handleChange = (e) => {
    let inputValue1 = e.target.value;
    inputValue1 = inputValue1.replace('(', '');
    inputValue1 = inputValue1.replace(')', '');
    // props.data.billedUnits = inputValue;
    // inputValue = parseFloat(inputValue).toFixed(0);
    // inputValue = parseFloat(inputValue);

    setInputValue(inputValue1);
    dispatch(setDisabled(false));
    const updateTabs = localStore;
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/units-selected-claim' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.filter(
        (item) => item.navTo !== '/units-selected-claim'
      );
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
      history.push({
        pathname: newObj.length > 0 ? newObj[0].navTo : '/dashboard',
      });
    }
   
    props.setStateChange('edit', true);
  };

  const isDisabled = useMemo(() => {
    let disabled = false;
    
    // For numOfUnits and billedUnits columns, disable when in display mode
    if (column?.colId === 'numOfUnits' || column?.colId === 'billedUnits') {
      disabled = selectedClaimMode === 'display';
    } else {
      if (selectedClaimMode === 'display') {
        disabled = true;
      } else if (selectedClaimMode !== 'display' && hasAccess === true) {
        disabled = false;
      }
    }
    
    return disabled;
  }, [selectedClaimMode, column?.colId, hasAccess]);

  const checkNumberValidation = (rx, amountVal) => {
    let val = false;
    if (rx.test(amountVal?.toString()?.replace('-', '').trim())) {
      val = true;
    }
    return val;
  };

  const handleOnKeyDownEvent = (e) => {
    let inputId = null;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      inputId = `label_${props.column.colId}_${
        e.key === 'ArrowDown' ? rowIndex + 1 : rowIndex - 1
      }`;
      handleOnKeyDownEventWithSelectValue(e, inputId);
    } else if (e.key === 'Tab' && props.column?.colId === 'numOfUnits') {
      inputId = `label_billedUnits_${rowIndex}`;
      handleOnKeyDownEventWithSelectValue(e, inputId);
    }
  };

   // Helper function to find the actual input element
  const findInputElement = (inputId) => {
    // First try to find by ID directly
    let inputElement = document.getElementById(inputId);
    
    // If not found, try to find input inside a container with that ID
    if (!inputElement) {
      const container = document.querySelector(`[id="${inputId}"]`);
      if (container) {
        inputElement = container.querySelector('input') || container.querySelector('textarea');
      }
    }
    
    // If still not found, try querySelector with input ID
    if (!inputElement) {
      inputElement = document.querySelector(`input#${inputId}`);
    }
    
    return inputElement;
  };

  // Helper function to check if an input is enabled
  const isInputEnabled = (inputElement) => {
    if (!inputElement) return false;
    // Check if disabled attribute exists and is not false
    if (inputElement.disabled === true) return false;
    // Check if parent TextField is disabled
    const textField = inputElement.closest('.MuiInputBase-root');
    if (textField && textField.classList.contains('Mui-disabled')) return false;
    // Check if the input has disabled class
    if (inputElement.classList.contains('Mui-disabled')) return false;
    return true;
  };

  const findNextEnabledField = (startRow, startCol, direction = 'forward') => {
    const maxRows = 1000; 
    let currentRow = startRow;
    let currentCol = startCol;
    let attempts = 0;
    
    while (attempts < maxRows) {
      if (direction === 'forward') {
        if (currentCol === 'numOfUnits') {
          currentCol = 'billedUnits';
        } else {
          currentCol = 'numOfUnits';
          currentRow++;
        }
      } else {
        if (currentCol === 'billedUnits') {
          currentCol = 'numOfUnits';
        } else {
          currentCol = 'billedUnits';
          currentRow--;
        }
      }
      
      if (currentRow < 0) break; 
      
      const inputId = `label_${currentCol}_${currentRow}`;
      const inputElement = findInputElement(inputId);
      
      if (inputElement && isInputEnabled(inputElement)) {
        return { inputId, inputElement };
      }
      
      attempts++;
    }
    
    return null;
  };

  // Helper function to focus and select input using requestAnimationFrame
  const focusAndSelectInput = (inputElement) => {
    if (!inputElement) return;
    
    requestAnimationFrame(() => {
      inputElement.focus();
      
      requestAnimationFrame(() => {
        const selectText = () => {
          if (inputElement.setSelectionRange && inputElement.value) {
            try {
              inputElement.setSelectionRange(0, inputElement.value.length);
            } catch (err) {
              if (inputElement.select) {
                inputElement.select();
              }
            }
          } else if (inputElement.select) {
            inputElement.select();
          }
        };
        
        selectText();
        
        requestAnimationFrame(() => {
          selectText();
        });
      });
    });
  };

  // New handler for 508 compliance - only navigate between numOfUnits and billedUnits
  const handleOnKeyDownEvent508 = (e) => {
    if (e.key === 'Tab') {
      e.preventDefault();
      e.stopPropagation();
      
      const direction = e.shiftKey ? 'backward' : 'forward';
      const result = findNextEnabledField(rowIndex, props.column?.colId, direction);
      
      if (result && result.inputElement) {
        requestAnimationFrame(() => {
          focusAndSelectInput(result.inputElement);
        });
      }
    } else if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      e.stopPropagation();
      
      const direction = e.key === 'ArrowDown' ? 'forward' : 'backward';
      const startCol = props.column?.colId;
      let currentRow = rowIndex;
      const maxRows = 1000;
      let attempts = 0;
      let found = false;
      
      while (attempts < maxRows && !found) {
        if (direction === 'forward') {
          currentRow++;
        } else {
          currentRow--;
        }
        
        if (currentRow < 0) break;
        
        const inputId = `label_${startCol}_${currentRow}`;
        const inputElement = findInputElement(inputId);
        
        if (inputElement && isInputEnabled(inputElement)) {
          found = true;
          requestAnimationFrame(() => {
            focusAndSelectInput(inputElement);
          });
        }
        
        attempts++;
      }
    }
  };

  return (
    <div
      className={`fullWidth w-100 selectedClaim ${
        value !== null
          ? parseFloat(value) < 0 || value.toString().includes('(')
            ? isRed
              ? 'negativeValue red'
              : 'negativeValue'
            : 'positiveValue'
          : 'positiveValue'
      }`}
    >
      <label
        className="m-0 hide-elm"
        htmlFor={`textfield_${column.colId}_${rowIndex}`}
      >
        <span>label</span>{' '}
      </label>
      {node?.rowPinned ? (
        <TextField
          label={`label_${props.column.colId}`}
          id={`label_${props.column.colId}_${rowIndex}`}
          className="frr-display-hidden-label"
          fullWidth
          placeholder=""
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            maxlength: props.maxlength || 14,
            id: `label_${props.column.colId}_${rowIndex}`,
          }}
          InputProps={{ disableUnderline: true }}
          value={inputValue}
          onBlur={handleBlur}
          onChange={handleChange}
          helperText=""
          disabled
          style={{
            color:
              value !== null
                ? value &&
                  (parseFloat(value) < 0 || value?.toString()?.includes('(')) &&
                  props.data.claimIdVO
                  ? 'red !important'
                  : '#000 !important'
                : '#000 !important',
          }}
        />
      ) : column?.colId === 'numOfUnits' ? (
        <TextField
          label={`label_${props.column.colId}_${rowIndex}`}
          id={`label_${props.column.colId}_${rowIndex}`}
          className="frr-display-hidden-label"
          fullWidth
          placeholder=""
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            maxLength: 18,
            id: `label_${props.column.colId}_${rowIndex}`,
          }}
          InputProps={{ disableUnderline: true }}
          value={inputValue}
          onFocus={handleFocus}
          onBlur={(e) => {
            if (!isDisabled) {
              handleBlur(e);
            }
          }}
          onChange={(e) => {
            if (!isDisabled) {
              if (e.target.value && e.target.value?.includes('.')) {
                const rx = /^[0-9]{0,13}(\.[0-9]{0,4})?$/;
                if (checkNumberValidation(rx, e.target.value)) {
                  handleChange(e);
                }
              } else {
                const rxWithout = /^[0-9]{0,13}?$/;
                if (checkNumberValidation(rxWithout, e.target.value)) {
                  handleChange(e);
                }
              }
            }
          }}
          onKeyDown={is508NotReq ? handleOnKeyDownEvent508 : handleOnKeyDownEvent}
          helperText=""
          disabled={isDisabled || !isEnablebyRole}
          style={{
            color:
              value !== null
                ? props?.value &&
                  (parseFloat(props?.value) < 0 ||
                    props?.value?.toString()?.includes('(')) &&
                  data.claimIdVO
                  ? 'red !important'
                  : '#000 !important'
                : '#000 !important',
          }}
        />
      ) : column?.colId === 'billedUnits' ? (
        <TextField
          label={`label_${props.column.colId}_${rowIndex}`}
          id={`label_${props.column.colId}_${rowIndex}`}
          className="frr-display-hidden-label"
          fullWidth
          placeholder=""
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            maxLength: 27,
            id: `label_${props.column.colId}_${rowIndex}`,
          }}
          InputProps={{ disableUnderline: true }}
          value={inputValue}
          onFocus={handleFocus}
          onBlur={(e) => {
            if (!isDisabled) {
              handleBlur(e);
            }
          }}
          onChange={(e) => {
            if (!isDisabled) {
              if (e.target.value && e.target.value?.includes('.')) {
                const rx = /^[0-9]{0,20}(\.[0-9]{0,6})?$/;
                if (checkNumberValidation(rx, e.target.value)) {
                  handleChange(e);
                }
              } else {
                const rxWithout = /^[0-9]{0,20}?$/;
                if (checkNumberValidation(rxWithout, e.target.value)) {
                  handleChange(e);
                }
              }
            }
          }}
          onKeyDown={is508NotReq ? handleOnKeyDownEvent508 : handleOnKeyDownEvent}
          helperText=""
          disabled={isDisabled || !isEnablebyRole}
          style={{
            color:
              value !== null
                ? props?.value &&
                  (parseFloat(props?.value) < 0 ||
                    props?.value?.toString()?.includes('(')) &&
                  data.claimIdVO
                  ? 'red !important'
                  : '#000 !important'
                : '#000 !important',
          }}
        />
      ) : (
        ''
      )}

      <CommonModal
        open={openModal}
        viewAction
        viewHeader
        className="frr-rightAlignment"
        onOk={() => {
          handleCloseModal();
        }}
        okTitle="OK"
        onClose={() => {
          handleCloseModal();
        }}
        closeTitle="Cancel"
        modalTitle="Change Units for a Claim"
        childrenComponent={<div className="p-3"> {modalMessage}</div>}
      />
    </div>
  );
});

export default CustomSelectedClaimTextField;
